export function PDFIcon({
  size = 24,
  className,
}: {
  className?: string;
  size?: number;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0 17V7H3.54057C4.17605 7 4.73726 7.12081 5.2242 7.36242C5.71938 7.60403 6.10727 7.96197 6.38788 8.43624C6.66848 8.91051 6.80878 9.49664 6.80878 10.1946C6.80878 10.8747 6.66436 11.4519 6.3755 11.9262C6.09489 12.4004 5.707 12.7629 5.21182 13.0134C4.72488 13.255 4.1678 13.3758 3.54057 13.3758H1.91884V17H0ZM1.91884 11.5638H3.55295C3.8253 11.5638 4.06051 11.5056 4.25859 11.3893C4.45666 11.2729 4.60934 11.1119 4.71663 10.906C4.83217 10.7002 4.88995 10.4631 4.88995 10.1946C4.88995 9.91723 4.83217 9.67562 4.71663 9.4698C4.60934 9.26398 4.45666 9.10291 4.25859 8.98658C4.06051 8.87025 3.8253 8.81208 3.55295 8.81208H1.91884V11.5638Z"
        fill="currentColor"
      />
      <path
        d="M8.28708 17V7H11.2953C12.2939 7 13.1605 7.21477 13.895 7.6443C14.6296 8.07383 15.199 8.66443 15.6034 9.41611C16.0078 10.1678 16.21 11.0268 16.21 11.9933C16.21 12.9597 16.0078 13.8233 15.6034 14.5839C15.199 15.3356 14.6296 15.9262 13.895 16.3557C13.1605 16.7852 12.2939 17 11.2953 17H8.28708ZM10.2059 15.1879H11.3448C11.9473 15.1879 12.4673 15.0582 12.9047 14.7987C13.3421 14.5302 13.6805 14.1588 13.9198 13.6846C14.1674 13.2013 14.2912 12.6376 14.2912 11.9933C14.2912 11.34 14.1674 10.7763 13.9198 10.302C13.6805 9.82774 13.3421 9.46085 12.9047 9.20134C12.4673 8.94183 11.9473 8.81208 11.3448 8.81208H10.2059V15.1879Z"
        fill="currentColor"
      />
      <path
        d="M17.6864 17V7H24V8.81208H19.6052V11.349H23.381V13.1611H19.6052V17H17.6864Z"
        fill="currentColor"
      />
    </svg>
  );
}
